import { procurementAPI } from "../../axios";
export const state = {
    isPoLoading: false,
}
export const mutations = {
    SET_PO_LOADING(state, data){
        state.isPoLoading = data;
    }
}
export const actions = {

    //Po
    GetPendingPo(context, data){
        return procurementAPI.get(`Po/Pending/${data.cycle}/${data.campusId}`);
    },
    GetFPendingPo(context, data){
        return procurementAPI.get(`Po/Filtered/Pending/${data.cycle}/${data.campusId}`);
    },
    GetUnreceivedPo(context, data){
        return procurementAPI.get(`Po/Unreceived/${data.cycle}/${data.campusId}`);
    },
    GetFUnreceivedPo(context, data){
        return procurementAPI.get(`Po/Filtered/Unreceived/${data.cycle}/${data.campusId}`);
    },
    GetPostedPo(context, data){
        return procurementAPI.get(`Po/Posted/${data.cycle}/${data.campusId}`);
    },
    GetFPostedPo(context, data){
        return procurementAPI.get(`Po/Filtered/Posted/${data.cycle}/${data.campusId}`);
    },
    GetSinglePo(context, data){
        return procurementAPI.get(`Po/${data}`);
    },
    UpdatePo(context, data){
        return procurementAPI.put(`Po/${data.id}`, data);
    },
    DeletePo(context, data){
        return procurementAPI.delete(`Po/${data}`);
    },
    CreatePo(context, data){
        return procurementAPI.post(`Po/Create/${data.campusId}`, data);
    },
    ReAwardPo(context, data){
        return procurementAPI.post(`Po/ReAward/${data.campusId}`, data);
    },
    PostPo(context, data){
        return procurementAPI.put(`Po/Post/${data}`);
    },
    ReceivePo(context, data){
        return procurementAPI.put(`Po/Receive/${data.id}/${data.date}`);
    },
    GetPONumber(context, data){
        return procurementAPI.get(`Po/PONumber/${data.cycle}/${data.campusId}`);
    },
    GetPOFundSource(context, data){
        return procurementAPI.get(`Po/FundSource/${data}`);
    },
    PoObligation(context, data){
        return procurementAPI.post(`Po/Obligation/${data.id}/${data.status}`);
    },
    MoveToCampus(context, data){
        return procurementAPI.post(`Po/Move/${data.id}/${data.campusId}`);
    },
    FindPo(context, data){
        return procurementAPI.post(`Po/Find/${data.lastId}`, data);
    },
    GetFindPoDetails(context, data){
        return procurementAPI.get(`Po/Details/${data}`);
    },

}